import React, { useEffect, useState } from 'react';
import { useTranslation } from '@i18n/client';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Dropdown } from '@components/Dropdown';
import { Language } from './types';
import { LanguageOptions } from '@constants/languages';

type LanguageSwitcherProps = {
  className?: string;
};

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className }) => {
  const { i18n } = useTranslation();
  const { locale } = useParams<{ locale: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [language, setLanguage] = useState(LanguageOptions[0]);

  useEffect(() => {
    const selectedLanguage = LanguageOptions.find(
      (lang: Language) => lang.shortCode.toLowerCase() === i18n.language
    );
    if (selectedLanguage) {
      setLanguage(selectedLanguage);
    }
  }, [i18n.language]);

  const handleChangeLanguage = (lang: Language) => {
    const newLang = lang.shortCode.toLowerCase();
    setLanguage(lang);

    const newPath = location.pathname.replace(`/${locale}`, `/${newLang}`);
    navigate(newPath + location.search);
  };

  return (
    <Dropdown
      className={className}
      value={language}
      options={LanguageOptions}
      onSelect={handleChangeLanguage}
      toTop
    />
  );
};

export default LanguageSwitcher;
